if (window.location.hostname == 'guichet.thd83.org' || window.location.hostname == 'guichet.adn83.fr') { // window.location.hostname == 'staging.guichet.sud-thd.net'
    window.urlapi = "https://sudthd-api.clicmap.fr/api/";
    window.IGNkey = "pratique";
} 
else if (window.location.hostname == 'staging.guichet.adn83.fr/') {
    window.urlapi = "https://sudthd-api-staging.clicmap.fr/api";
    window.IGNkey = "pratique";
}
else {
    window.urlapi = "https://sudthd-api-dev.clicmap.fr/api/"; //Erreur Request URL: https://sudthd-api-dev.clicmap.fr/api/log, Class 'AppEntityRequest' does not exist
    window.IGNkey = "pratique";
}




window.ADDRESSAPI = "https://data.geopf.fr/geocodage/search/?q="
window.ADDRESSREVERSEAPI = "https://data.geopf.fr/geocodage/reverse/"
window.mapFile = "/var/www/html/ress/sudthd/sudthd.map"
window.url_mapProxy = 'https://mapproxy.clicmap.fr/mapproxy/service';
window.url_mapServer = "https://www.clicmap.fr/cgi-bin/mapserv";